import PropTypes from 'prop-types';
import React, { Component } from 'react';
import injectSheet from 'react-jss';

import DepartmentItem from '~/components/Shared/DepartmentItem/DepartmentItem';
import { injectIntl } from 'react-intl';
import { withRouting } from '~/routing/withRouting';

import { evisortBlue } from '../../../assets/shared-styles/general';
import { MODAL_NAME } from '../../../types/modal.types';
import PlusIcon from '../Icons/PlusIcon';
import styles from './EcDepartmentsTable.styles';

class EcDepartmentsTable extends Component {
  goToDepartment = (department) => {
    const { navigate, clientId } = this.props;
    navigate(
      `/admin/console/${clientId}/department/${department.department_id}`,
    );
  };

  renderDepartmentItems() {
    const { classes, clientId, listItems, handleShowModal, intl } = this.props;
    if (!listItems.length)
      return (
        <div>
          <div>
            <div className={classes.noDataMessage}>
              {intl.formatMessage({
                id: 'EcDepartmentsTable.noDepartments',
                defaultMessage: 'No departments found.',
                description: 'Message when no departments are available',
              })}
            </div>
          </div>
        </div>
      );
    return listItems.map((item, index) => {
      return (
        <DepartmentItem
          onClick={this.goToDepartment}
          clientId={clientId}
          item={item}
          index={index}
          key={`department-${item.department_id}`}
          handleShowModal={handleShowModal}
        />
      );
    });
  }

  render() {
    const { classes, header, handleShowModal, intl } = this.props;

    return (
      <div
        className={classes.departmentTable}
        data-testid="department-table-container"
      >
        {header ? (
          <div className={classes.tableHeaderWrapper}>
            <div className={classes.tableHeaderText}>{header}</div>
            <div className={classes.headerButtonWrapper}>
              <button
                className={classes.headerButton}
                onClick={() => handleShowModal(MODAL_NAME, null, true)}
              >
                <PlusIcon size="16" color={evisortBlue} />
                <span>
                  {intl.formatMessage({
                    id: 'EcDepartmentsTable.addSubdepartment',
                    defaultMessage: 'Add Subdepartment',
                    description: 'Button text to add a new subdepartment',
                  })}
                </span>
              </button>
            </div>
          </div>
        ) : null}
        {this.renderDepartmentItems()}
      </div>
    );
  }
}

EcDepartmentsTable.propTypes = {
  classes: PropTypes.object.isRequired,
  listItems: PropTypes.array.isRequired,
  handleShowModal: PropTypes.func,
};

export default injectSheet(styles)(withRouting(injectIntl(EcDepartmentsTable)));
